import { render } from "./LbrxInfoPopup.vue?vue&type=template&id=1f8c6593&scoped=true"
import script from "./LbrxInfoPopup.vue?vue&type=script&lang=js"
export * from "./LbrxInfoPopup.vue?vue&type=script&lang=js"

import "./LbrxInfoPopup.vue?vue&type=style&index=0&id=1f8c6593&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f8c6593"]])

export default __exports__